import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { updateSegment, getPendingSurvey } from "src/docuclipper/api";

const initialState: {
  open: boolean;
  survey: string;
  loading: boolean;
  pendingSurvey: any;
} = {
  open: false,
  survey: "",
  loading: false,
  pendingSurvey: null,
};

const slice = createSlice({
  name: "Survey",
  initialState,
  reducers: {
    openSurvey(state, action: PayloadAction<string>) {
      state.survey = action.payload;
      state.open = true;
    },
    closeSurvey(state) {
      state.open = false;
      state.survey = "";
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setPendingSurvey(state, action: PayloadAction<any>) {
      // Normalize undefined/non-object payloads (e.g. a 429 retry that
      // exhausts and resolves to undefined) to null so downstream selectors
      // can rely on nullish checks instead of guarding every property access.
      const payload = action.payload;
      state.pendingSurvey =
        payload && typeof payload === "object" ? payload : null;
    },
  },
});

export const { openSurvey, closeSurvey, setLoading, setPendingSurvey } = slice.actions;

export const fetchPendingSurvey = () => async (dispatch, getState) => {
  const state = getState();
  if (state.Survey.loading) {
    return;
  }

  dispatch(setLoading(true));

  try {
    const response = await getPendingSurvey();
    dispatch(setPendingSurvey(response ?? null));
    dispatch(setLoading(false));
  } catch (error) {
    console.error("Error fetching pending survey:", error);
    dispatch(setLoading(false));
  }
};

export const updateSegmentAction = ({ segment }) =>
  async (dispatch, getState) => {
    try {
      const segmentUpdated = await updateSegment({ segment });
      // console.log({ segmentUpdated });
    } catch (err) {
      console.error(err);
    }
  };

export default slice.reducer;
